import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['tr', 'en', 'ar', 'de'],
    debug: false,
    resources: messages,
    detection: {
      order: ['navigator', 'htmlTag', 'localStorage', 'cookie'],
      caches: ['localStorage'],
      lookupLocalStorage: 'bursaLang',
      convertDetectedLanguage: (lng: string) => {
        const base = lng.split('-')[0].toLowerCase();
        const supported = ['tr', 'en', 'ar', 'de'];
        return supported.includes(base) ? base : 'en';
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
